import { MontuCampaignStatusChoices } from "@repo/graphql/gql/graphql";

export type CampaignPhase = "scheduled" | "accepting" | "closed" | "finished";

export interface CampaignPhaseInput {
  status: MontuCampaignStatusChoices;
  startsAt: string;
  endsAt: string | null;
}

/**
 * Where a campaign is in its life, derived the way the backend decides who can
 * apply: a campaign is either `OPEN` or `FINISHED`; "applications closed" is not
 * a status, it is `endsAt` having passed. Public and private campaigns alike
 * accept applications while `OPEN` and `startsAt <= now <= endsAt`; a null
 * `endsAt` (private campaigns) means the window never closes.
 */
export const getCampaignPhase = (
  campaign: CampaignPhaseInput,
  now: Date,
): CampaignPhase => {
  if (campaign.status === MontuCampaignStatusChoices.Finished) {
    return "finished";
  }
  const nowMs = now.getTime();
  if (nowMs < new Date(campaign.startsAt).getTime()) return "scheduled";
  if (campaign.endsAt != null && nowMs > new Date(campaign.endsAt).getTime()) {
    return "closed";
  }
  return "accepting";
};

export const isAcceptingApplications = (
  campaign: CampaignPhaseInput,
  now: Date,
): boolean => getCampaignPhase(campaign, now) === "accepting";

export const CAMPAIGN_PHASE_LABEL: Record<CampaignPhase, string> = {
  scheduled: "Programada",
  accepting: "Recibiendo postulaciones",
  closed: "Postulaciones cerradas",
  finished: "Finalizada",
};
